import { getComponentData } from '@owc/aem-component-data-util';
import { subscribe, type PageEnvironmentConnectionState } from '@seamless/one-context';
import type { AemAnalyticsData, AemData } from './types';
import { mapEnvToAemData } from './utils';

export async function getAemDataFromAEM<ComponentData>(
  componentId: string,
  dataEditMode?: string | null,
): Promise<AemData<ComponentData>> {
  const aemEnv = (await getEnvData()).pageEnvironmentVariables;
  const { payload } = getComponentData(componentId);

  // @ts-ignore
  return mapEnvToAemData(location.href, aemEnv, payload, dataEditMode == 'true');
}

async function getEnvData(): Promise<PageEnvironmentConnectionState> {
  if (import.meta.env.MODE === 'test') return window.aemNamespace;

  return new Promise((resolve) => {
    subscribe<PageEnvironmentConnectionState>('PageConnection', {
      tenant: 'owpi',
      componentName: import.meta.env.APP_NAME,
      callback: resolve,
    });
  });
}

export function getAemAnalyticsData(dataset: DOMStringMap): AemAnalyticsData {
  return {
    aemModulename: dataset.aemModulename,
    aemModuletrackingname: dataset.aemModuletrackingname,
    aemTargetingHiddenInitially: dataset.aemTargetingHiddenInitially as 'checked' | undefined,
    aemTargetingUseCase: dataset.aemTargetingUseCase,
    aemTargetingUseCaseVariant: dataset.aemTargetingUseCaseVariant,
    aemTargetingVehicle: dataset.aemTargetingVehicle,
  };
}
